document.addEventListener("DOMContentLoaded", function () {
	const overlay = document.getElementById("menu-overlay");
	const header = document.getElementById("header");

	let closeTimer;

	// =========================
	// SCROLL LOCK HELPERS
	// =========================
	function lockScroll() {
		document.body.classList.add("no-scroll");
	}

	function unlockScroll() {
		const menuOpen = document.querySelector(".submenu.visible");
		if (!menuOpen) {
			document.body.classList.remove("no-scroll");
		}
	}

	// =========================
	// ANIMATION HELPERS ✨
	// =========================
	function showElement(el) {
		el.classList.remove("opacity-0", "invisible", "translate-y-4", "scale-95");
		el.classList.add("opacity-100", "visible", "translate-y-0", "scale-100");
	}

	function hideElement(el) {
		el.classList.remove("opacity-100", "visible", "translate-y-0", "scale-100");
		el.classList.add("opacity-0", "invisible", "translate-y-4", "scale-95");
	}

	function showOverlay(type) {
		overlay.dataset.type = type || "menu";
		overlay.classList.remove(
			"opacity-0",
			"invisible",
			"opacity-100",
			"visible",
			"backdrop-blur-sm",
		);
		overlay.classList.add("opacity-100", "visible", "backdrop-blur-sm");
	}

	function hideOverlay() {
		overlay.classList.remove(
			"opacity-100",
			"visible",
			"backdrop-blur-sm",
			"opacity-0",
			"invisible",
		);
		overlay.classList.add("opacity-0", "invisible");
		delete overlay.dataset.type;
	}

	// =========================
	// MENU
	// =========================
	function closeAllMenus() {
		document.querySelectorAll(".submenu").forEach(hideElement);
		document.querySelectorAll(".menu-item a").forEach((a) => {
			a.classList.remove("bg-[#E8E8E8]", "border-[#D5D5D5]");
		});
		if (overlay.dataset.type === "menu") hideOverlay();
		unlockScroll();
	}

	document.querySelectorAll(".menu-item").forEach((item) => {
		const menuId = item.dataset.menuId;
		const submenu = document.querySelector(
			`.submenu[data-menu-id="${menuId}"]`,
		);
		if (!submenu) return;

		item.addEventListener("mouseenter", () => {
			clearTimeout(closeTimer);

			closeAllMenus(); // hide other submenus

			showElement(submenu);
			showOverlay("menu");
			lockScroll();

			item.querySelector("a").classList.add("bg-[#E8E8E8]", "border-[#D5D5D5]");
		});

		item.addEventListener("mouseleave", () => {
			closeTimer = setTimeout(() => {
				if (!submenu.matches(":hover")) closeAllMenus();
			}, 150);
		});

		submenu.addEventListener("mouseenter", () => clearTimeout(closeTimer));
		submenu.addEventListener("mouseleave", () => {
			closeTimer = setTimeout(closeAllMenus, 150);
		});
	});

	// Overlay click
	overlay.addEventListener("click", () => {
		closeAllMenus();
	});

	// ESC key support
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") {
			closeAllMenus();
		}
	});

	// =========================
	// HEADER SCROLL
	// =========================
	let lastScroll = 0;
	window.addEventListener("scroll", () => {
		if (!header) return; // no #header element in the current markup
		const currentScroll = window.pageYOffset;

		if (currentScroll > lastScroll && currentScroll > 50) {
			header.style.opacity = "0";
			header.style.transform = "translateY(-10px)";
			header.style.pointerEvents = "none";
		} else {
			header.style.opacity = "1";
			header.style.transform = "translateY(0)";
			header.style.pointerEvents = "auto";
		}

		lastScroll = currentScroll;
	});
});
